const images = {
    logoSVG: require('~/assets/images/logo.svg').default,
    ai: require('~/assets/images/ai.png'),
    atlassian: require('~/assets/images/atlassian.png'),
    blog01: require('~/assets/images/blog01.png'),
    blog02: require('~/assets/images/blog02.png'),
    blog03: require('~/assets/images/blog03.png'),
    blog04: require('~/assets/images/blog04.png'),
    blog05: require('~/assets/images/blog05.png'),
    dropbox: require('~/assets/images/dropbox.png'),
    google: require('~/assets/images/google.png'),
    logoPNG: require('~/assets/images/logo.png'),
    people: require('~/assets/images/people.png'),
    possibility: require('~/assets/images/possibility.png'),
    shopify: require('~/assets/images/shopify.png'),
    slack: require('~/assets/images/slack.png'),
};

export default images;
